import { AppBar, Badge, Box, Button, Toolbar } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import api from '../../api';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('commonStore', 'menuStore', 'cartStore', 'orderStore')
@observer
class Bottom extends Component {
  handleClickOrder = async () => {
    const { commonStore, menuStore, cartStore, orderStore, t, history, location } = this.props;

    if (cartStore.cartData.menus.length === 0) {
      commonStore.setSnackbar(true, t('cart.error.empty'));
      return;
    }

    if (menuStore.storeData.orderMethod === '1') {
      // QR생성 주문
      const result = await api.addQrOrder(orderStore.orderData);
      history.replace(`/qr-order/${result.data}${location.search}`);
    } else {
      // PG 결제 주문
      if (menuStore.storeData.culture === 'ja-JP') {
        // 일본 매장인 경우 결제 페이지로 이동
        history.push({
          pathname: `/${commonStore.companyId}/${commonStore.storeCode}/payment`,
          search: location.search,
        });
      } else {
        // 한국매장의 경우 주문 페이지로 이동
        history.push(`/${commonStore.companyId}/${commonStore.storeCode}/order${location.search}`);
      }
    }
  };

  render() {
    const { t, cartStore, orderStore } = this.props;
    return (
      <AppBar position="fixed" color="primary" className="bottom">
        <Toolbar variant="dense" style={{ padding: '0' }}>
          <Button fullWidth onClick={this.handleClickOrder} className="bottom-button">
            <Box className="bottom-button-title">
              <Badge badgeContent={cartStore.totalCnt}>{t('order.button.order')}</Badge>
            </Box>
            <Box bgcolor="secondary.main" className="bottom-button-amount">
              <CurrencyDisplay amount={orderStore.orderAmount} size="large" />
            </Box>
          </Button>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withTranslation()(withRouter(Bottom));
